export default __webpack_public_path__ + "static/media/info-icon-outline-black.84a4ff56.svg";